import styled from "styled-components";

const FloatContainer = styled.div`
  position: ${({ height }) => (height > 600 ? "sticky" : "relative")};
  top: ${({ height }) => (height > 600 ? "90px" : "0px")};
  margin-top: 20px;
`;

export default FloatContainer;
